// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3rBf9","title":"Info_title__2oM3K","selects":"Info_selects__1tJPu","requiredAsterisk":"Info_requiredAsterisk__hFhZQ"};